/**
 * ! 신규 사이트 추가시 반드시 아래 문서 업데이트 해주세요.
 * https://gitlab.somansa.com/vdis/docs/-/wikis/%EC%82%AC%EC%9D%B4%ED%8A%B8-%EB%84%A4%EC%9E%84-%EC%A0%95%EC%9D%98
 */

export const siteName = 'lgd';
export { MultiFactor } from './components';
export const protocolHandler = true;
